import { formatAmount } from "@babia/checks";
import type { LogStats } from "../../lib/stats.ts";

/** Last feed and today's totals; changes only when the family tracks them. */
export function Stats({ stats, diaper }: { stats: LogStats; diaper: boolean }) {
  return (
    <section className="mt-[22px] flex items-end gap-3.5" aria-label="Summary">
      <div className="min-w-0">
        <div className="kicker">Last feed</div>
        <div className="heading mt-1.5 text-[40px] leading-none tracking-[-0.03em]">
          {stats.lastFeedAgo}
        </div>
        <div className="mt-1.5 text-[13px] opacity-70">{stats.lastFeedDetail}</div>
      </div>
      <div className="ml-auto shrink-0 text-right">
        <div className="kicker">Today</div>
        <div className="heading mt-1.5 text-[26px] leading-[1.1]">
          {formatAmount(stats.todayOz, stats.unit)}
        </div>
        <div className="text-[13px] opacity-70">
          {stats.todayFeeds} {stats.todayFeeds === 1 ? "bottle" : "bottles"}
          {diaper
            ? ` · ${stats.todayDiapers} ${stats.todayDiapers === 1 ? "change" : "changes"}`
            : null}
        </div>
      </div>
    </section>
  );
}
